export default "__VITE_ASSET__Cxt08jQY__"